<template>
  <transition name="modal">
    <div
      class="modal-mask"
      :class="[
        classWrapper,
        {
          redesign: redesign,
          is_big: is_big,
          modal_rates: modal_rates,
          'is-sticky': isSticky,
          'is-white': isWhite,
          small: small
        }
      ]"
    >
      <div class="modal-wrapper">
        <div v-on-clickaway="close" class="modal-container">
          <template v-if="showModalClose">
            <i v-if="redesign" class="modal__close icon icon-close" @click="close"></i>
            <a v-else class="modal-close" @click="close"></a>
          </template>

          <div class="modal-header">
            <slot name="header"></slot>
          </div>

          <div class="modal-body">
            <slot name="body"></slot>
          </div>

          <div
            v-if="hasFooter"
            class="modal-footer"
            :class="{
              'modal-footer--left': footerAlign === 'left',
              'modal-footer--right': footerAlign === 'right'
            }"
          >
            <slot name="footer">
              <vbutton class="button-ok" label="common.ok" @click="$emit('close')" />
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'Modal',

  mixins: [clickaway],

  props: {
    visible: Boolean,
    classWrapper: String,

    showModalClose: {
      type: Boolean,
      default: true
    },

    hasFooter: {
      type: Boolean,
      default: true
    },

    redesign: {
      type: Boolean,
      default: false
    },

    is_big: {
      type: Boolean,
      default: false
    },

    modal_rates: {
      type: Boolean,
      default: false
    },

    isSticky: {
      type: Boolean,
      default: false
    },

    isWhite: {
      type: Boolean,
      default: false
    },

    small: {
      type: Boolean,
      default: false
    },

    footerAlign: {
      type: String,
      default: 'center'
    },

    isCloseDisabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      show: false
    };
  },

  created() {
    document.getElementsByTagName('html')[0].className = 'modalIsOpened';
  },

  beforeDestroy() {
    document.getElementsByTagName('html')[0].className = '';
  },

  methods: {
    close() {
      if (this.isCloseDisabled) {
        return;
      }

      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.xls-import .modal-footer {
  justify-content: flex-start;
}

.button-ok {
  min-width: 100px;
}

.modal {
  &__close {
    position: absolute;
    top: 15px;
    right: 15px;
    color: $main-dark;
    cursor: pointer;
    font-size: 20px;
    transition: color 0.3s;

    &:hover {
      color: $green-hover;
      transition: color 0.3s;
    }
  }
  .button-ok {
    min-width: 100px;
  }
}
</style>
